export class SubscriptionEnvironment {
  public static getName = () => 'benzinga-subscriptions';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://accounts.benzinga.com/'),
  });
}
